export default __webpack_public_path__ + "static/GT-America-Standard-Regular-18928fb24e10bed358aa68054c078970.woff2";